"use client";

import { ChevronRight } from "lucide-react";
import Link from "next/link";
import { siteConfig } from "@/lib/config";
import { useTranslations } from "@/lib/hooks/use-translations";

export default function FooterClient({ locale }: { locale?: 'de' | 'en' } = {}) {
  
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:grid-cols-2 mt-8">
      {siteConfig.footer(locale).map((section, index) => (
        <div key={index} className="mb-5">
          <h2 className="font-semibold">{section.title}</h2>
          <ul>
            {section.links.map((link, linkIndex) => (
              <li key={linkIndex} className="my-2">
                <Link
                  href={link.href}
                  className="group inline-flex cursor-pointer items-center justify-start gap-1 text-muted-foreground duration-200 hover:text-primary hover:opacity-90"
                  target={link.href.startsWith('http://') || link.href.startsWith('https://') ? "_blank" : undefined}
                >
                  {link.icon && link.icon}
                  {link.text}
                  <ChevronRight className="h-4 w-4 translate-x-0 transform opacity-0 transition-all duration-300 ease-out group-hover:translate-x-1 group-hover:opacity-100" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
